/**
 * Opens an empty tab inside the click (popup blockers allow only that), to be pointed at a URL once the server
 * answers. `opener` is cut at once: the page that loads there (an uploaded file served as HTML, wa.me) must not be
 * able to navigate the Ops tab (reverse tabnabbing). `window.open(…, 'noopener')` cannot be used here, because it
 * returns null and the tab could then never be pointed at the link.
 */
export function openBlankTab(): Window | null {
  const tab = window.open('', '_blank');
  if (tab) {
    try {
      tab.opener = null;
    } catch {
      // A browser that refuses the write still gets the tab; it holds about:blank only until we set its location.
    }
  }
  return tab;
}
